import React, { useContext, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import AppContext from "../../hooks/appContext";
import CartItem from "../CartItem/cartItem";
import placeholder from "../../assets/img/placeholder.svg";
import doToast from '@/modules/storefront/components/doToast/doToast';
import { calcCartTotal, formatMoney } from '@/modules/storefront/utils/helpers';
import { isClient } from '@/utils/environment';

const CartList = (props) => {
  const {
    cart,
    addToCart,
    changeCartPage,
    reduceProductQty,
    removeFromCart,
    thisStoreProducts,
    currentCurrency,
  } = useContext(AppContext);
  const [favoritesList, setFavoritesList] = useState([]);

  let favorites = isClient() && localStorage.getItem("storefrontFavorites");


  useEffect(() => {
    let faveArray = JSON.parse(favorites);

    if (faveArray && faveArray?.length > 0) {
      const matchingObjects = thisStoreProducts?.filter(obj => faveArray?.includes(obj.slug));
      setFavoritesList(matchingObjects);
    }

  }, [thisStoreProducts, favorites]);

  const getCurrentAmount = (amounts) => {
    const targetObject = amounts?.find(obj => obj.currency_id === currentCurrency);
    return targetObject?.amount;
  }

  function isEqual(obj1, obj2) {
    return obj1.slug === obj2.slug;
  }

  const removeFromStorage = (product) => {
    let faveArray = JSON.parse(favorites);

    if (faveArray && faveArray.length > 0) {
      const newFavoritesArray = favoritesList.filter(obj => !isEqual(obj, product));
      setFavoritesList(newFavoritesArray);

      if (faveArray.includes(product?.slug)) {
        const newArray = faveArray.filter(element => element !== product?.slug);
        const newFavorites = JSON.stringify(newArray);
        localStorage.setItem('storefrontFavorites', newFavorites);
      }
    }
  }

  const handleChangeCartPage = () => {
    if (cart.length > 0) {
      changeCartPage("shipping")
    }
  }

  const checkoutButtonClasses = `${styles.btn} ${styles['btn-checkout']}`;


  return (
    <>
      <div className={styles['list-cart']}>
        <div className={styles['cart-item-list']}>
          {
            cart && cart.length ?
              cart.map((item, index) => {
                return (
                  <div key={index}>
                    <CartItem
                      image={item.images[0] ? item.images[0].url : placeholder}
                      name={item.name}
                      price={getCurrentAmount(item.amounts)}
                      qty={item.qty}
                      product={item}
                      addQty={addToCart}
                      reduceQty={reduceProductQty}
                      removeItem={removeFromCart}
                    />
                  </div>
                )
              })
              :
              <div className={styles['empty-cart-msg']}>Your cart is empty</div>
          }

          {
            favoritesList && favoritesList.length > 0 ?
              <>
                <div className={styles.cart_fav_list} >
                  <p className={styles.fav_list_title}>Favorite Items</p>
                  {
                    favoritesList.map((product, id) => {
                      return (
                        <div key={"product" + id}>
                          <CartItem
                            image={product.images[0] ? product.images[0].url : placeholder}
                            name={product.name}
                            price={getCurrentAmount(product.amounts)}
                            qty="1"
                            product={product}
                            addQty={addToCart}
                            removeItem={removeFromStorage}
                            itemSource="favorites"
                          />
                        </div>
                      )
                    })
                  }
                </div>
              </>
              :
              null
          }

        </div>
      </div>

      <div className={styles['cart-summary']}>
        <div className={styles['summary-bottom']}>
          <button
            className={checkoutButtonClasses}
            onClick={handleChangeCartPage}
          >
            Checkout
          </button>
        </div>
      </div>
    </>
  )
}

export default CartList;